<template>
  <div>
    <PublicPageHeader
      :title="title"
      :description="description"
      :image="headerImage"
    />
    <v-container
      class="mt-10"
      v-if="!loading"
    >
      <ResourceSample
        v-for="item in items"
        :key="item.id"
        :type="title"
        :details="item"
      />
    </v-container>
    <v-row
      justify="center"
      align="center"
      class="pt-4"
      v-else
    >
      <v-progress-circular
        :size="70"
        color="#5c648b"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import PublicPageHeader from "./component/PublicPageHeader";
import ResourceSample from "./component/ResourceSample";

import Axios from "../../api/BaseAxios";

import { API_CLIENT_URL } from "../../constants/urls";

export default {
  name: "PublicFilteredResources",
  components: {
    PublicPageHeader,
    ResourceSample,
  },
  data () {
    return {
      headerImage: require("@/assets/allResource.svg"),
      title: "",
      resource_type_list: [],
      language_list: [],
      resource_skill_list: [],
      resource_tag_list: [],
      age_group_list: [],
      loading: true,
      description: ""
    };
  },
  created () {
    this.title = this.$route.params.title.replace("-", " ");
    this.getFilterData();
    switch (this.title) {
      case "Skills":
        this.description = 'The different resources contributed by community members have been categorised based on different parameters. In terms of skills the categorisation has been made to denote which resources will contribute in improving what individual abilities of the person. These abilities may be functional, personal or knowledge- based'
        break
      case "Language":
        this.description = 'The different resources contributed by community members have been categorised based on different parameters. In terms of age group the categorisation has been made to denote which resources are more suitable for a particular Language.'
        break
      case "Age Group":
        this.description = 'The different resources contributed by community members have been categorised based on different parameters. In terms of age group the categorisation has been made to denote which resources are more suitable for a particular Age Group.'
        break
      case "Resource Type":
        this.description = 'The different resources contributed by community members have been categorised based on different parameters. The resource type denotes the type of resource file uploaded by the creator such as video, audio, worksheet and activity.'
        break
      case "Tags":
        this.description = 'The different resources contributed by community members have been categorised based on different parameters. The resource type denotes the type of resource file uploaded by the creator such as video, audio, worksheet and activity.'
        break
      default:
        break
    }
  },
  computed: {
    items () {
      switch (this.title) {
        case "Skills":
          return this.resource_skill_list;
        case "Language":
          return this.language_list;
        case "Age Group":
          return this.age_group_list;
        case "Resource Type":
          return this.resource_type_list;
        case "Tags":
          return this.resource_tag_list;
        default:
          return this.resource_skill_list;
      }
    },
  },
  watch: {},
  methods: {
    getFilterData () {
      var self = this;
      self.loading = true;

      const successHandler = (res) => {
        self.loading = false;
        self.resource_type_list = res.data.resource_types_list;
        self.language_list = res.data.languages_list;
        self.resource_skill_list = res.data.skills_list;
        self.resource_tag_list = res.data.tags_list;
        self.age_group_list = res.data.age_group_list;
      };

      const failureHandler = (res) => {
        console.log(res);
        self.loading = false;
      };

      Axios.request_GET(
        API_CLIENT_URL.resourceFilters,
        {},
        {},
        successHandler,
        failureHandler,
        false,
        false
      );
    },
  },
  mounted () { },
};
</script>

<style scoped></style>
